import React from 'react';
import cn from 'classnames';

interface AutoSaveStatusLabelProps {
	isSaving: boolean
	isSaved: boolean
}

const AutoSaveStatusLabel = (props: AutoSaveStatusLabelProps) => {
	const {
		isSaving,
		isSaved,
	} = props;
	return (
		<div className="success-label">
			<span className={`icon icon-only ${isSaved ? 'icon-check-circle' : ''}`} />
			<span
				className={cn(
					'status',
				)}
			>
				{isSaving ? 'Saving' : null}
				{isSaved ? 'Saved' : null}
			</span>
		</div>
	);
};

export default AutoSaveStatusLabel;
